import {
  Image as SystemImage,
  ImageProps as SystemImageProps,
} from '@hover/blueprint';
import React from 'react';

export interface ImageProps extends SystemImageProps {
  avif?: string;
  webp?: string;
}

const Image = ({
  avif,
  decoding = 'async',
  loading = 'lazy',
  maxWidth = '100%',
  webp,
  ...props
}: ImageProps) => (
  <picture>
    {avif && <source srcSet={avif} type="image/avif" />}
    {webp && <source srcSet={webp} type="image/webp" />}
    <SystemImage
      {...props}
      decoding={decoding}
      loading={loading}
      maxWidth={maxWidth}
    />
  </picture>
);

export { Image };
